import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { Container } from '../../Common/Common.styles'
import withServices from '../../../../HOCs/withServices'
import NavBar from '../../../../components/CustomNav/CustomNav.Component';
import SimpleLoader from '../../../../common/simpleLoader.Component'
import ScreenViewer from "../../../../common/screenViewerHtml";
import MultipleChoiceInteraction from '../../../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component';
import DragDropInteraction from '../../../../components/DnDInteraction/DragDropInteraction.Component';
import RecallInteraction from '../../../../components/RecallInteraction/RecallInteraction.Component';
import MultipleChoiceMultiInteraction from '../../../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component'
import { processRedWords } from '../../../../common/utils';

import { toast, ToastContainer } from 'react-toastify';
import Steps, { Step } from "rc-steps";
import Loader from 'react-loader'
import { Player, BigPlayButton } from "video-react";


import { APIBASE, MEDIABASE, PROXIED_MEDIABASE } from "../../../../common/constants";
import { array } from 'prop-types';


interface IState {
  startTime: number;
  screens: any;
  currentScreenIdx: number;
  currentScreen: any;
  loaded: boolean;
  currentInteraction: any;
  interactionLoaded: boolean;
  toPlexing: boolean;
  // data: any;
}
interface IProps {
  history?: any;
  services?: any;
}
const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
const styles = {
  maxWidth: '80%',
  minWidth: '650px',
}
class OnboadingLesson extends Component<IProps, IState> {
  private ls = window.localStorage;
  constructor(props) {
    super(props);
    this.state = {
      startTime: 0,
      // data: {},
      screens: [] as any,
      currentScreenIdx: 0,
      currentScreen: {},
      loaded: false,
      currentInteraction: {},
      interactionLoaded: false,
      toPlexing: false
    }
    this.currentid = this.currentid.bind(this);
    // this.closeLesson = this.closeLesson.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.showContent = this.showContent.bind(this);
    this.interactionComplete = this.interactionComplete.bind(this);
    this.showVideo = this.showVideo.bind(this);
    this.showImage = this.showImage.bind(this);
    this.loadInteractionScreen = this.loadInteractionScreen.bind(this);
    this.showScreen = this.showScreen.bind(this);
    this.selectScreen = this.selectScreen.bind(this);
    this.renderLessonContent = this.renderLessonContent.bind(this);
    this.difficulty = this.difficulty.bind(this);
    this.fetchInteraction = this.fetchInteraction.bind(this);
  }

  public async componentDidMount() {
    const startTime = new Date().getTime();
    this.setState({ startTime });

    // load data
    const { services: { adminAPI } } = this.props;
    const res = await adminAPI.getLessonScreensInteractionsAnonymous(this.currentid(), this.difficulty());
    const key = 'screens'
    if (res.ok) {
      const screens = res.data[key];
      this.setState({
        screens, loaded: true
      });
    }
  }

  public componentWillUnmount() {
    const endTime = new Date().getTime();
    const { startTime } = this.state;
    const lessonDuration = Math.round((endTime - startTime) / 60000);
    const today = weekdays[new Date().getDay()];
    // console.log(`Start ${startTime} Stop ${endTime} Duration ${lessonDuration} ID ${this.currentid()} TodayTotal ${this.ls.getItem(today)}`);

    const todayTotal = this.ls.getItem(today);
    if (todayTotal === null) {
      this.ls.setItem(today, `${lessonDuration}`);
    } else {
      let currentTotalDuration = parseInt(todayTotal, 10);
      currentTotalDuration += lessonDuration;
      this.ls.setItem(today, `${currentTotalDuration}`);
    }
  }

  public fetchInteraction(screen) {
    const { services: { adminAPI }} = this.props;
    const res = adminAPI.getInteractionFromUrl(screen.interaction_url.replace("/api/v1/", ""));
    if(res.ok) {
      this.setState({currentInteraction: res.data, interactionLoaded: true});
      console.error(JSON.stringify(res.data))
    }
  }
  public currentid() {
    const key = 'match';
    return this.props[key].params.id
  }

  public difficulty() {
    const key = 'match';
    return this.props[key].params.difficulty;
  }

  public lessonName() {
    const currentLesson = this.ls.getItem('currentlesson');
    if(currentLesson === null) {
      return `Lesson: ${this.currentid}`;
    }else{
      return currentLesson;
    }
  }

  // public closeLesson() {
  //   const { history } = this.props;
  //   const endTime = new Date().getTime();
  //   const { startTime } = this.state;
  //   const lessonDuration = Math.round((endTime - startTime) / 60000);
  //   const today = weekdays[new Date().getDay()];
  //   // console.log(`Start ${startTime} Stop ${endTime} Duration ${lessonDuration} ID ${this.currentid()} TodayTotal ${this.ls.getItem(today)}`);

  //   const todayTotal = this.ls.getItem(today);
  //   if (todayTotal === null) {
  //     this.ls.setItem(today, `${lessonDuration}`);
  //   } else {
  //     let currentTotalDuration = parseInt(todayTotal, 10);
  //     currentTotalDuration += lessonDuration;
  //     this.ls.setItem(today, `${currentTotalDuration}`);
  //     history.goBack();
  //   }
  // }
  public previousPage() {
    // const { data } = this.state;
    if (this.state.currentScreenIdx > 0) {
      const newval = this.state.currentScreenIdx - 1;
      this.setState({ currentScreenIdx: newval });
      // this.selectScreen();
      // setTimeout(this.loadScreenData, 100);
    }
  }

  public async nextPage() {
    const { screens } = this.state;
    if (this.state.currentScreenIdx < this.state.screens.length - 1) {
      const { services: {adminAPI}} = this.props;
      const newval = this.state.currentScreenIdx + 1;
      // check if next screen has an interaction
      const nextScreen = screens[newval];
      if(screens[newval].ScreenType === 1) {
        const url = nextScreen.interaction_url;
        const res = await adminAPI.getInteractionFromUrl(url.replace("/api/v1/", ""));
        if(res.ok){
          this.setState({currentInteraction: res.data, interactionLoaded: true});
        }else {
          toast.error("Ooops, please refresh your browser to try again");
        }
      }
      this.setState({ currentScreenIdx: newval });
    } else if (this.state.currentScreenIdx === this.state.screens.length - 1) {
      // finished all preview screens
      const { history } = this.props;
      const completedLessons = this.ls.getItem('completedlessons');
      if(completedLessons === null) {
        const lessons = new Array();
        lessons.push(
          {
            "lessonid": this.currentid(),
            "difficulty": this.difficulty()
          }
        );
        const completedLessons = {lessons}
        this.ls.setItem('completedlessons', JSON.stringify(completedLessons));
      }else {
        const completed= JSON.parse(completedLessons);
        const found = completed.lessons.find(lesson => lesson.lessonid === `${this.currentid()}` && lesson.difficulty === `${this.difficulty()}`);

        if(found) {
          console.log("Lesson already completed");
        }else{
          completed.lessons.push(
          {
            "lessonid": this.currentid(),
            "difficulty": this.difficulty()
          }
        );
        }
        this.ls.setItem('completedlessons', JSON.stringify(completed));
      }
      this.setState({toPlexing: true})
      // history.push("/plexing");
    }
  }

  public showContent(screen) {
    return (
      <div className="lesson-preview--content-wrapper">
        <div className="lesson-preview--content">
          <div style={{ backgroundColor: screen.DisplayData.background }}>
            <ScreenViewer
              screenid={screen.id}
              screenpdf={screen.DisplayData.html}
              // screenbg={screen.DisplayData.background}
              pageNumber={1}
              style={{ padding: '8px' }}
            />
          </div>
        </div>
      </div>
    );
  }


  public showVideo(screen) {
    return (
      <div className="lesson-preview--content">
        <div className="lesson-video-container">
          <Player
            // style={{ height: "500" }}
            playsInline={true}
            poster={PROXIED_MEDIABASE + "assets/" + "download.jpg"}
            src={PROXIED_MEDIABASE + "assets/" + screen.VideoUrl}
            height={640}
            width={960}
          >
            {/* <BigPlayButton position="center" /> */}
          </Player>
        </div>
      </div>
    );
  }

  public showImage(screen) {
    console.log("Image screen: " + JSON.stringify(screen, null, 4));
    return (
      <div className="lesson-preview--content" style={styles}>
        <div className="lesson-image-container">
          <img
            // style={{ width: "858px"}}
            className="lesson-screen-image"
            src={PROXIED_MEDIABASE + "assets/" + screen.VideoUrl}
          >
            {/* <BigPlayButton position="center" /> */}
          </img>
        </div>
      </div>
    );
  }

  public showInteraction(screen) {
    return(
      <div className="lesson-preview--content" style={styles}>
        {this.loadInteractionScreen(screen)}
      </div>
    )
  }

  public loadInteractionScreen(screen) {
    const { currentInteraction, interactionLoaded } = this.state;

    if (interactionLoaded) {
      if (currentInteraction.interaction_type === "choice") {
        if (currentInteraction.choice_type === "single_choice") {
          return (
            <MultipleChoiceInteraction
              oncomplete={this.interactionComplete}
              demomode={true}
              show={true}
              lessonid={screen.Lesson}
              interactionid={currentInteraction.id}
              completiontext={currentInteraction.completion_text}
              submittext={"Submit"}
              introtext={currentInteraction.intro_text}
              question={currentInteraction.question_text}
              answers={currentInteraction.choice_answers}
              penalty={currentInteraction.penalty}
              timelimit={currentInteraction.time_limit}
            />
          );
        }
        else {
          return (
            <MultipleChoiceMultiInteraction
              oncomplete={this.interactionComplete}
              demomode={true}
              show={false}
              lessonid={screen.Lesson}
              interactionid={currentInteraction.id}
              completiontext={currentInteraction.completion_text}
              submittext={"Submit"}
              introtext={currentInteraction.intro_text}
              question={currentInteraction.question_text}
              answers={currentInteraction.choice_answers}
              penalty={currentInteraction.penalty}
              timelimit={currentInteraction.time_limit}
            />
          );
        }
      }

      else if (
        currentInteraction.interaction_type === "draganddrop") {
        return (
          <DragDropInteraction
            oncomplete={this.interactionComplete}
            demomode={true}
            show={true}
            lessonid={screen.Lesson}
            interactionid={currentInteraction.id}
            completiontext={currentInteraction.completion_text}
            submittext={"Submit"}
            introtext={currentInteraction.intro_text}
            dragquestions={
              currentInteraction.options}
            penalty={currentInteraction.penalty}
            timelimit={currentInteraction.time_limit}
          />
        );
      }
      else if (
        currentInteraction.interaction_type === "recall"
      ) {
        return (
          <RecallInteraction
            oncomplete={this.interactionComplete}
            demomode={true}
            show={true}
            lessonid={screen.Lesson}
            interactionid={currentInteraction.id}
            completiontext={currentInteraction.completion_text}
            submittext={"Submit"}
            introtext={currentInteraction.intro_text}
            question={currentInteraction.paragraph_copy}
            redwords={processRedWords(
              currentInteraction.recall_words
            )}
            penalty={currentInteraction.penalty}
            timelimit={currentInteraction.time_limit}
          />
        );
      }
      else {
        return (<p>Unkown interaction Type</p>)
      }
    } else {
      return <p>No Interactions Fetched!</p>
    }
  }

  public interactionComplete() {
    {this.nextPage()}
  }

  public showScreen(screen) {
    if (!screen) {
      return (<p>No Screen Selected</p>);
    }
    if (screen.ScreenType === 0) {
      return this.showContent(screen);
    }
    else if (screen.ScreenType === 1) {
      return this.showInteraction(screen);
    }
    else if (screen.ScreenType === 2) {
      return this.showVideo(screen);
    }
    else if (screen.ScreenType === 3) {
      return this.showImage(screen);
    }
    else {
      return (
        <p>Unkown screen type</p>
      )
    }
  }

  public selectScreen() {
    const { currentScreenIdx, screens } = this.state;
    // data.ScreenSelected = false;  
    console.log("BeforeSetScreens: " + JSON.stringify(screens, null, 4))


    if (screens[currentScreenIdx].ScreenType === 1) {
      console.log('fetch inter')
      console.log(screens[currentScreenIdx]);
      const res = this.props.services.adminAPI.getInteractionFromUrl(screens[currentScreenIdx].interaction_url.replace("/api/v1/", ""));

      if (res.ok) {

        const currentInteraction = res.data;

        screens[currentScreenIdx].interaction = currentInteraction;

        console.log(currentInteraction);

        this.setState({ screens });
      } else {
        console.log("NO INteraction!");
      }

    }
  }

  public navButtons() {
    if (this.state.currentScreenIdx > 0) {
      return (
        <div className="lesson-screens-navigation" style={styles}>
          <button className="green-button" style={{ marginRight: 9 }} onClick={this.previousPage}>
            Prev
        </button>
          <p>
            Page {this.state.currentScreenIdx + 1} of{" "}
            {this.state.screens.length}
          </p>
          <button className="green-button" style={{ marginRight: 9 }} onClick={this.nextPage}>
            Next
        </button>


        </div>
      );
    } else {
      return (
        <div className="lesson-screens-navigation" style={styles}>
          <button className="green-button" onClick={this.nextPage}>Start</button>
        </div>
      );
    }
  }

  public renderLessonContent() {
    if (this.state.loaded) {
      const keyscreentype = "ScreenType";
      const { screens, currentScreenIdx } = this.state;
      const currentScreen = screens[currentScreenIdx];
      return (
        <div className="lesson-preview--screen-content">
          <div className="lesson-preview--header">
            {/* <p className="go-back" onClick={this.goBack}>
                &lt; Exit
              </p> */}
          </div>
          <h2 className="lesson-title">
            <span>{this.lessonName()}</span>
          </h2>
          <div className="lesson-preview--content-container">
            <div>
              {this.showScreen(currentScreen)}
              {this.navButtons()}
            </div>

            <div className="lesson-preview--content-sidebar">
              <div className="lesson-preview--content-sidebar-nav">
                <h6>Your Performance Learning Pathways</h6>
                <Steps
                  direction="vertical"
                  current={this.state.currentScreenIdx}
                  size="small"
                >
                  {this.state.screens.map((screen) => {
                    const title = `${screen.Title[0].toUpperCase()}${screen.Title.toLowerCase().slice(
                      1
                    )}`;

                    return (
                      <Step
                        key={screen.id}
                        title={title}
                        disabled={screen[keyscreentype] === 1 ? true : false}
                      />
                    );
                  })}
                </Steps>
              </div>
            </div>
          </div>
          {/* <p>Dummy Lesson to test measuring time</p>
          <button className="green-button" onClick={this.closeLesson}>End Lesson</button> */}
        </div>
      );
    } else {
      return <Loader color="#3ee9f7" />
    }
  }

  public render() {
    if(this.state.toPlexing) {
      return <Redirect to='/plexing' />
    }
    return (
      <Container>
        <NavBar />
        <ToastContainer />
        <SimpleLoader loaded={this.state.loaded} />
        {this.renderLessonContent()}

      </Container>
    );
  }
}


export default withServices(OnboadingLesson);


// WEBPACK FOOTER //
// ./src/pages/Onboard/Student/OnboardingLesson/OnboadingLesson.Component.tsx